export class AgeVerificationApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Returns the latest age verification attempt for the current account session,
     * or null if no attempt exists. Account session required.
     */
    async getCurrent() {
        return this.client.get('/api/age-verification/current');
    }
    /**
     * Returns the active verification provider so consent copy and links can
     * name the vendor the user's data will actually reach. No session required.
     */
    async getProvider() {
        return this.client.get('/api/age-verification/provider');
    }
    /**
     * Drops a leftover pending attempt when the current IP was the only reason
     * verification was required. Account session required.
     */
    async skip() {
        return this.client.post('/api/age-verification/skip', {});
    }
}
//# sourceMappingURL=age-verification-api.js.map